var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationManBc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3458",
    "data-name": "Group 3458",
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.601,
    height: 101.371,
    viewBox: "0 0 97.601 101.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M31.092,0C16.308,0,4.756,7.376.971,18.382S4.458,49.71,22.994,51.535s28.4-12.95,46.753-10.49S87.218,22.2,74.5,13.089,45.877,0,31.092,0Z",
    transform: "matrix(-0.914, 0.407, -0.407, -0.914, 97.601, 47.223)",
    fill: "#e3f1dc",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man",
    transform: "translate(20.828 26.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M36.964,9.478s-1.7-5.341,1.146-7.7S48.163-.583,50.037,3.692a11.255,11.255,0,0,1,.278,6.806c-.375,1.683-.494,3.339-1.624,5.035C46.123,19.386,36.964,9.478,36.964,9.478Z",
    transform: "translate(-16.478 -0.193)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M43.219,31.925c2.656.963,6.976-3.684,6.976-3.684L48.964,17.31c1.083-.367,1.723-2.477,1.231-3.081-.623-.765-1.959-.094-1.959-.094l-.026,1.148a.228.228,0,0,1-.452.036L47.5,13.935a2.016,2.016,0,0,1-.886-1.219c-.355-1.04-.2-2.676-1.061-2.676-2.42.262-4.154.655-5.983.655a5.744,5.744,0,0,1-2.338-.449s0,4.386.083,5.608C37.607,19.833,39.2,23.3,42.2,23.3a7.928,7.928,0,0,1-.14,3.445C41.56,28.535,40.562,30.962,43.219,31.925Z",
    transform: "translate(-16.805 -4.333)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445",
    transform: "translate(25.103 9.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M45.591,30.289s2.65,0,5.256-3.631c0,0-.674,7.423-5.551,7.884Z",
    transform: "translate(-45.296 -21.287)",
    fill: "#f2aaa9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M56.651,17.621s.854-.516,1.364,0-.533,2.138-.533,2.138",
    transform: "translate(-50.07 -17.391)",
    fill: "none",
    stroke: "#f49394",
    strokeWidth: 0.553
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M45.688,18.084a.409.409,0,1,0-.41-.409A.409.409,0,0,0,45.688,18.084Z",
    transform: "translate(-20.185 -7.371)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M39.223,18.084a.409.409,0,1,0-.41-.409A.409.409,0,0,0,39.223,18.084Z",
    transform: "translate(-17.468 -7.371)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M40.813,23.437s-1.142.907-1.142,1.123c0,.125.654-.062,1.189-.216a3.692,3.692,0,0,1,1.918,0c1.282.283,1.675-.017,1.368-.241a13.7,13.7,0,0,0-1.964-.719,4.747,4.747,0,0,1-.658.107A5.844,5.844,0,0,1,40.813,23.437Z",
    transform: "translate(-17.828 -9.943)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M41.945,18.558a25.6,25.6,0,0,0-.381,2.749c0,.706,1.659.278,1.659.278",
    transform: "translate(-18.624 -8.195)",
    fill: "none",
    stroke: "#181b32",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M46.146,14.344a2.233,2.233,0,0,0-1.015-.308,2.16,2.16,0,0,0-1.051.141c-.194.11-.309.253-.208.434s.331.019.455-.05a1.541,1.541,0,0,1,.8-.174,2.841,2.841,0,0,1,.9.19c.189.079.313.192.368.093S46.3,14.441,46.146,14.344Z",
    transform: "translate(-19.578 -6.01)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M37.643,14.109a2.232,2.232,0,0,1,1.045-.182,2.159,2.159,0,0,1,1.026.267c.179.132.276.289.154.456s-.331-.021-.446-.105a1.541,1.541,0,0,0-.775-.271,2.844,2.844,0,0,0-.914.079c-.2.055-.334.152-.377.047S37.482,14.187,37.643,14.109Z",
    transform: "translate(-16.853 -5.965)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M37.624,18.522a1.637,1.637,0,1,0-1.639-1.637A1.638,1.638,0,0,0,37.624,18.522Z",
    transform: "translate(-16.278 -6.523)",
    fill: "none",
    stroke: "#6c7c65",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M44.9,18.522a1.637,1.637,0,1,0-1.639-1.637A1.638,1.638,0,0,0,44.9,18.522Z",
    transform: "translate(-19.336 -6.523)",
    fill: "none",
    stroke: "#6c7c65",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M41.4,26.46l3.572-.052a2.313,2.313,0,0,1-1.637,1.221C42.29,27.7,41.4,26.46,41.4,26.46Z",
    transform: "translate(-18.93 -11.214)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M41.641,18.073h.937",
    transform: "translate(-18.656 -7.71)",
    fill: "none",
    stroke: "#6c7c65",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M49.094,17.584l4.127-.673",
    transform: "translate(-21.79 -7.222)",
    fill: "none",
    stroke: "#6c7c65",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(15.205 60.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M28.218,109.031S31.978,110.692,41,111,55.7,108.159,55.7,108.159l-1.469-3.145-23.875.318Z",
    transform: "translate(-28.218 -105.014)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M43.435,80.38a38.349,38.349,0,0,1-11.647,2.008,78.5,78.5,0,0,1-13.219-1.437,18.1,18.1,0,0,1-1.164-6.3c0-3.518.537-8.993.537-8.993l-.537-9.715s-.463.976-3.937,3.45a24.1,24.1,0,0,1-6.575,3.363L2.5,56.615s14.933-14.884,16.069-15.39S27.243,39.9,27.243,39.9s.551,3.453,3.13,3.453,5.1-3.809,5.1-3.809,6.618.835,10.69,2.893c5.257,2.423,9.662,24.325,9.662,27.036s-1.517,4.892-2.115,4.07-4.609-3.232-6.743-3.232c0,0,.076-2.571.64-2.9l-3.227-7.134L42.3,70.308Z",
    transform: "translate(-2.201 -16.735)",
    fill: "#bfdbb1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(14.955 22.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M45.052,48.708s-.483,1.425-.653,1.875S41.506,72.676,41.918,80.12l3.01,4.3,3.37-4.243-.839-29.013-.17-2.434Z",
    transform: "translate(-33.71 -43.573)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M46.077,47.084s.662,2.14,1.423,2.316,2.737-1.49,2.737-1.49l-.813-1.81-2.059-.224-.864.571Z",
    transform: "translate(-35.477 -42.383)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M46.509,43.44a4.292,4.292,0,0,0-2.247,2.234,6.892,6.892,0,0,1-.79-5.411",
    transform: "translate(-34.272 -40.023)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M51.6,43.272l1.5,3.144s3.453-1.349,4.913-6.568",
    transform: "translate(-37.8 -39.849)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M75.43,65.33l-1.852,8.239",
    transform: "translate(-47.038 -50.562)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M27.788,56.01l.545,10.856",
    transform: "translate(-27.788 -46.643)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M80.321,87.63a11.213,11.213,0,0,1,4.912,1.281",
    transform: "translate(-49.873 -59.937)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.553
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M56.558,109.134s-4.774,2.538-4.937,3.083c-.043.145.1.254.339.336a3.818,3.818,0,0,0,3.54-1.046l.848-.706Z",
    transform: "translate(-22.849 -45.993)",
    fill: "#f2aaa9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M66.888,92.626l-10.635,8.838-3.357,4.5a3.243,3.243,0,0,0-.26.411l-2.682,5.045a.533.533,0,0,0,.915.545l2.663-4.019-2.165,5.5a.5.5,0,0,0,.909.434l2.87-5.074-1.625,4.772a.523.523,0,0,0,.973.382l1.983-4.446-.6,3.557a.44.44,0,0,0,.852.206l.985-3.107s3.163-4.036,2.543-5.855l13.7-8.324a17.861,17.861,0,0,0-3.294-2.244A8.431,8.431,0,0,0,66.888,92.626Z",
    transform: "translate(-22.125 -39.053)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M12.431,62.622c4.931.4,9.544.854,11.909.236s4.266-.482,5.107-.754S32.1,57.648,32.1,57.648a1.369,1.369,0,0,1,.874,1.728l-.809,2.467s3.449,1.525,3.65,2.129-.514,1.294-.74,1.534a1.934,1.934,0,0,1-.978,2.1s-.515,1.278-1.356,1.543a1.34,1.34,0,0,1-1.5.842c-1.189-.129-3.874-2.424-3.874-2.424s-9.727,1.694-14.863,2.782-9.786-.392-9.788-4S7.5,62.224,12.431,62.622Z",
    transform: "translate(-2.293 -24.348)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M7.963,65.253s-.528,6.172,1.614,8.993c0,0-6.428-.431-7.333-3.587S3,66.546,3.952,66.133A27.151,27.151,0,0,1,7.963,65.253Z",
    transform: "translate(-1.984 -27.545)",
    fill: "#bfdbb1",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationManBc);
export default __webpack_public_path__ + "static/media/Illustration-man-bc.a2e4e3043f40c1bca3135bd52a6106a9.svg";
export { ForwardRef as ReactComponent };